module.exports = __webpack_public_path__ + "img/5.4afdf6c2.png";